






































































































































































































































































































































































































































































































    import { Component, Watch } from "../../../Infrastructure/CorBase/CoreBase";
    //import htmlEditor from "../../../Components/HtmlEditor/BaseTLhtmlEditor.vue";

    //funguje
    //@ts-ignore
	import htmlEditor from "../../../../ClientApp/Components/HtmlEditorBase/BaseTLhtmlEditor.vue";

    import ContentDetailBase from "./ContentDetailBase";


    @Component({
        components: {
            htmlEditor
        }
    })

//    @Component
	export default class ContentDetail extends ContentDetailBase {

		///hlaska o prekroceni inputu po Ctrl+V
		private infoShortInput(maxLength: string): void {
			this.infoShortInputBase(maxLength);
		}

		@Watch('formData.url')
		onPropertyUrl(value: any, oldValue: any) {
			if (value !== oldValue) {
				if (this.showAudioStreamTag()) {
					this.setAudioStream();
				}
			}
        }



        disableSaveButton() {        
            var htmlNotChange = this.htmlEdit == this.htmlEditOld && this.showHtmlInput();        
            return this.validate() || (this.disabledSaveButton && (htmlNotChange || !this.showHtmlInput())) ;
        }



        changeTypeInfoText(typeInfo: number) {
            if (typeInfo == 1) {
                this.formData.isUrl = false;
                this.formData.isFromFile = false;
                this.formData.isText = true;
            }
            else if (typeInfo == 2) {
                this.formData.isUrl = false;
                this.formData.isText = false;
                this.formData.isFromFile = true;
            }
            else {
                this.formData.isText = false;
                this.formData.isFromFile = false;
                this.formData.isUrl = true;
            }
           
        }

        gotoUrl(item: any) {
            var url = (item.name as String).indexOf('http') == -1 ? 'https://' + item.name : item.name;
            window.open(url, '_blank');
        }

        changeHtmlEditor(html: string) {
            this.changeHtmlEditorBase(html);
        }


        changeTags(items: any): void {
            this.changeTagsBase(items);
        }

        goBackDetailTag(item: any): void {
            this.goBackDetailTagBase(item);
        }

		setAudioStream() {
            var audioTag = document.getElementById('idAudioStream');
            if ((audioTag as HTMLAudioElement) != null) {
                (audioTag as HTMLAudioElement).src = String(this.formData.url);
            }
        }



		gotoTask(item: any) {
            this.$router.push({ name: 'TaskDetail', params: { id: item }, query: { id: item } });
		}

		//deleteItem() {
		//	this.showMsgBoxTwo();
		//}

		created() {
			super.initializeRights('CON_Content_Create', 'CON_Content_Delete', 'CON_Content_Read', 'CON_Content_Update');
			super.setMainDescription('content.new', 'content.detail');
			if (this.styleFormNew) {
				this.loadEnums();
            }
            this.mainDataChanged = false;
            this.createdBase();
		}

		//tady musi byt kvuli spusteni pri prvnim
		updated() {
			this.setAudioStream();
        }

		mounted() {
            super.mounted();
            //TODO PRYC je to pouze na test
         //   this.refreshAfterUpdate();
		};		

	
        preventRefresh(event: any) {
            if (this.$store.state.askBeforeCancelEditing === true && this.formIsInEditMode && this.dataWasChanged()) {
                event.preventDefault(); event.returnValue = "";
            }
        }
        beforeMount() {
            window.addEventListener("beforeunload", this.preventRefresh);
        }

        beforeDestroy() {
            window.removeEventListener("beforeunload", this.preventRefresh);
            this.$store.commit("formIsInEditMode", false);
            this.$store.commit("mainDataChanged", false);
            this.beforeDestroyBase();
            clearInterval(this.timerHandle);
        }

		validate() {
			return this.validateBase();
		}

		isCorrectFile(value: any) {
			this.isCorrectFileBase(value);
		}

		isCorrectUrl(value: any) {
			this.isCorrectUrlBase(value);
		}

		isCorrectName(value: any) {
			this.isCorrectNameBase(value);
		}

		isCorrectContentType(value: any) {
			this.isCorrectContentTypeBase(value);
		}
	}
